import moment from 'moment';
import 'es6-shim';
import 'es7-shim';

export function runBlock ($rootScope, $window) {
  'ngInject';

  window.moment = moment;

  if (!Array.prototype.find) {
    Array.prototype.find = function(predicate) {
      if (this == null) {
        throw new TypeError('Array.prototype.find called on null or undefined');
      }
      if (!angular.isFunction(predicate)) {
        throw new TypeError('predicate must be a function');
      }
      var list = Object(this);
      var length = list.length >>> 0;
      var thisArg = arguments[1];
      var value;

      for (var i = 0; i < length; i++) {
        value = list[i];
        if (predicate.call(thisArg, value, i, list)) {
          return value;
        }
      }
      return undefined;
    };
  }

  if (!String.prototype.includes) {
    String.prototype.includes = function(search, start) {
      'use strict';

      if (search instanceof RegExp) {
        throw TypeError('first argument must not be a RegExp');
      }
      if (start === undefined) { start = 0; }
      return this.indexOf(search, start) !== -1;
    };
  }

  if(FileReader.prototype.readAsBinaryString === undefined) {
    FileReader.prototype.readAsBinaryString = function (fileData) {
      var binary = "";
      var pt = this;
      var reader = new FileReader();
      reader.onload = function () {
          var bytes = new Uint8Array(reader.result);
          var length = bytes.byteLength;
          for (var i = 0; i < length; i++) {
              binary += String.fromCharCode(bytes[i]);
          }
          pt.content = binary;
          pt.onload();
      };
      reader.readAsArrayBuffer(fileData);
    };
  }

  var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
  var isIEold = ( navigator.userAgent.match(/MSIE/i) ? true : false );

  isIE11 && angular.element(document.body).addClass("ie-11");
  isIEold && angular.element(document.body).addClass("ie-lt-11");

  $rootScope.$on('$locationChangeStart', function (event, next, current) { // eslint-disable-line
    let userInfo = angular.fromJson(localStorage.getItem("ngStorage-roedl-session"));
    let directLogInFlag;
    if(userInfo !== null)
      directLogInFlag = userInfo !== undefined ? userInfo.directOClogin : false;
    if(directLogInFlag){
      $window.location.href = $window.location.origin + '/calc/';
    }
  });

  $rootScope.$on('$routeChangeSuccess', (event, current/*,previous*/) => { // eslint-disable-line
    if (current.hasOwnProperty('$$route')) {
      $rootScope.page = current.$$route; // eslint-disable-line
    }
  });

  //bundle type
  $rootScope.BUNDLE = {
    type: window.BUNDLE !== undefined ? window.BUNDLE : 'roedl',
    date: window.BUILD_AT
  };
}
